<template>
    <v-layout row wrap align-center class="accept-check">
        <v-flex xs12 mt-4 class="policy-text">
            <v-checkbox color="ypo_blue" class="shrink mt-0" v-model="isCheckboxChecked"></v-checkbox>
            <span v-if="!isSpeakerView"
                >{{ loginConstants.privacyPolicy.TEXT_PART1 }}
                <a
                    @click="forwardToExternalLink(loginConstants.privacyPolicy.TEXT_PART2.replace('YPO ', ''))"
                    data-qe-id="login_privacy_link"
                >
                    {{ loginConstants.privacyPolicy.TEXT_PART2 }}
                </a>
                {{ loginConstants.privacyPolicy.TEXT_PART3 }}
                <a
                    @click="forwardToExternalLink(loginConstants.privacyPolicy.TEXT_PART4.replace('.', ''))"
                    data-qe-id="login_terms-of-use_link"
                >
                    {{ loginConstants.privacyPolicy.TEXT_PART4 }}
                </a>
            </span>

            <span v-if="isSpeakerView"
                >{{ loginConstants.privacyPolicy.TEXT_PART1 }}
                <a
                    @click="forwardToExternalLink(loginConstants.privacyPolicy.TEXT_PART5.replace('.', ''))"
                    data-qe-id="login_terms-of-use_link"
                >
                    {{ loginConstants.privacyPolicy.TEXT_PART5 }}
                </a>
            </span>
        </v-flex>
        <v-flex mt-3 align-center>
            <v-btn
                class="primary_btn"
                large
                block
                id="submit_btn"
                data-qe-id="submit_btn"
                color="ypo_blue"
                :disabled="!isCheckboxChecked || isSubmitting"
                @click="submit"
            >
                {{ loginConstants.SUBMIT }}
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
import { loginConstants } from '../login.constants';
import { mapGetters, mapActions } from 'vuex';
import { storeGetters } from '../../../store/storeGetters.constant';
import { storeAction } from '../../../store/storeActions.constant';

export default {
    name: 'PrivacyPolicy',
    data: () => ({
        loginConstants,
        isCheckboxChecked: false,
        isSubmitting: false,
        postbody: {
            TermsAndConditionsAcceptedOn: 'Web',
            TermsAndConditionsAccepted: true,
        },
    }),
    methods: {
        ...mapActions({
            saveTermsAndConditions: `auth/${storeAction.saveTermsAndConditions}`,
        }),

        forwardToExternalLink(displayName) {
            if (this.termsPrivacyURLs) {
                const linkObjects = this.termsPrivacyURLs.find(
                    (item) => item.name.toLowerCase() === displayName.toLowerCase(),
                );
                window.open(linkObjects.navigationUrl, '_blank');
            }
        },

        redirectUrl() {
            if (this.postLoginRedirectRoute) {
                window.open(this.postLoginRedirectRoute, '_self');
            } else {
                this.$router.push('/home');
            }
        },
        submit() {
            this.isSubmitting = true;
            this.saveTermsAndConditions(this.postbody).then(() => {
                this.redirectUrl();
            });
        },
    },
    computed: {
        ...mapGetters({
            postLoginRedirectRoute: `auth/${storeGetters.getPostLoginRedirectRoute}`,
            isSpeakerView: `auth/${storeGetters.isSpeakerView}`,
            currentUserId: `auth/${storeGetters.currentUserId}`,
            termsPrivacyURLs: `openAPI/${storeGetters.termsPrivacyURLs}`,
        }),
    },
};
</script>

<style lang="scss" scoped>
.accept-check {
    font-size: 12px;
    .v-input__slot {
        margin-bottom: 0px !important;
    }
    .policy-text {
        position: relative;
        padding-left: 36px;
    }
    .v-input--selection-controls {
        position: absolute;
        left: 4px;
    }
}
</style>
